import { render } from "./HistoryItem.vue?vue&type=template&id=0f7d137d&scoped=true&ts=true"
import script from "./HistoryItem.vue?vue&type=script&lang=ts"
export * from "./HistoryItem.vue?vue&type=script&lang=ts"

import "./HistoryItem.vue?vue&type=style&index=0&id=0f7d137d&lang=scss&scoped=true"

import exportComponent from "/var/www/tenanthub.au/runners/admin/root/tenanthub-admin/tenanthub-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f7d137d"]])

export default __exports__